import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import I18n from 'I18n';
import ConsentModal from 'conversations-visitor-experience-components/visitor-widget/ConsentModal';
import ConsentPromptV2 from 'conversations-visitor-experience-components/visitor-widget/components/ConsentPromptV2';
import ConsentPrompt from 'conversations-visitor-experience-components/visitor-widget/ConsentPrompt';
import { CHAT_THREAD } from 'conversations-visitor-experience-components/visitor-widget/constants/consentPromptVariants';
import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { EVENT_NAMES } from '../../usage-tracking/constants/eventNames';
import { consentToCookies } from '../../gdpr/actions/visitorConsentsToCookies';
import { declineCookies } from '../../gdpr/actions/visitorDeclinesCookies';
import { getIsExitIntentCookiePrompt } from '../../utils/gdprCookieConsentPromptHelpers';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
import { ChatWidgetLocaleContextConsumer } from 'conversations-visitor-experience-components/visitor-widget/ChatWidgetLocaleContext';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { gdprCookieConsentPromptMessage } from 'conversations-internal-schema/widget-data/operators/gdprCookieConsentPromptMessage';
import { getIsAIChatbot } from '../../selectors/widgetDataSelectors/getIsAIChatbot';
import { getShouldUseConsentPromptV2 } from '../../widget-data/selectors/widgetDataSelectors';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { getIsPortal53 } from '../../widget-data/operators/getIsPortal53';
import ConsentPromptWrapper from './ConsentPromptWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const CookieConsentPrompt = () => {
  const dispatch = useDispatch();
  const latestWidgetData = useSelector(getLatestWidgetData);
  const isAIChatBot = useSelector(getIsAIChatbot);
  const shouldUseConsentPromptV2 = useSelector(getShouldUseConsentPromptV2);
  const widgetColoring = useSelector(getColoring);
  const cookieConsentPromptMessage = gdprCookieConsentPromptMessage(latestWidgetData);
  const isExitIntentPrompt = useSelector(getIsExitIntentCookiePrompt);
  useEffect(() => {
    dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: 'view consent to cookies'
    }));
  }, [dispatch]);
  const handleConsentToCookies = () => {
    dispatch(consentToCookies());
  };
  const handleDeclineCookies = () => {
    dispatch(declineCookies());
  };
  return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
    children: locale => {
      const message = cookieConsentPromptMessage || I18n.text('conversations-visitor-ui.gdpr.consentToCookies.pageLoadCookieConsent', {
        locale
      });
      if (isExitIntentPrompt) {
        return /*#__PURE__*/_jsx(ConsentModal, {
          headerMessage: cookieConsentPromptMessage ? '' : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-ui.gdpr.consentToCookies.promptHeader",
            options: {
              locale
            }
          }),
          message: cookieConsentPromptMessage || I18n.text('conversations-visitor-ui.gdpr.consentToCookies.exitIntentCookieConsent', {
            locale
          }),
          onDeclineClick: handleDeclineCookies,
          onClick: handleConsentToCookies,
          useV2Style: shouldUseConsentPromptV2
        });
      }
      if (shouldUseConsentPromptV2) {
        return /*#__PURE__*/_jsx(ConsentPromptWrapper, {
          $isPortal53: getIsPortal53(),
          children: /*#__PURE__*/_jsx(ConsentPromptV2, {
            variant: CHAT_THREAD,
            consentMessage: message,
            onConsentAccept: handleConsentToCookies,
            showConsentButton: true,
            showDivider: false,
            isAIChatBot: isAIChatBot,
            accentColor: widgetColoring === null || widgetColoring === void 0 ? void 0 : widgetColoring.accentColor
          })
        });
      }
      return /*#__PURE__*/_jsx(ConsentPrompt, {
        message: cookieConsentPromptMessage || I18n.text('conversations-visitor-ui.gdpr.consentToCookies.pageLoadCookieConsent', {
          locale
        }),
        onClick: handleConsentToCookies,
        onClose: () => {},
        showButton: true
      });
    }
  });
};
CookieConsentPrompt.displayName = 'CookieConsentPrompt';
export default CookieConsentPrompt;